import { useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";

const LAYER_EXTRUDE_FLOOD = ({ layer, genangan_reducer }) => {
  const clickHandlerRef = useRef(null);

  const handleExtrusionClick = useCallback(async (e) => {
    try {
      if (!e) {
        throw new Error("Event object is missing");
      }
      if (!e.features || e.features.length === 0) {
        return;
      }
      const feature = e.features[0];
      if (!feature) {
        throw new Error("Feature data is invalid");
      }
      if (!feature.properties) {
        throw new Error("Feature properties are missing");
      }

      const value = feature.properties.VALUE;
      if (value === undefined || value === null) {
        throw new Error("Elevation VALUE property is missing");
      }
    } catch (error) {}
  }, []);

  const on_render = useCallback(async () => {
    try {
      const { map_object } = layer;
      if (!map_object) {
        throw new Error("Map object is not available");
      }
      const geojson_flood_square = genangan_reducer.geojson_flood_square;
      const flood_level_mdpl_meter_editable =
        genangan_reducer.flood_level_mdpl_meter_editable;

      const flood_level_cm_editable = genangan_reducer.flood_level_cm_editable;

      const enlarge_extrude = genangan_reducer.enlarge_extrude;
      const visibility_extrude = genangan_reducer.visibility_extrude;
      const min_mdpl = genangan_reducer.min_mdpl;

      if (flood_level_cm_editable === 0 || flood_level_cm_editable === "0") {
        if (map_object.getLayer("geojson_flood_square")) {
          map_object.removeLayer("geojson_flood_square");
        }
        if (map_object.getSource("geojson_flood_square")) {
          map_object.removeSource("geojson_flood_square");
        }
        if (clickHandlerRef.current) {
          map_object.off(
            "click",
            "geojson_flood_square",
            clickHandlerRef.current
          );
          map_object.off("mouseenter", "geojson_flood_square");
          map_object.off("mouseleave", "geojson_flood_square");
          clickHandlerRef.current = null;
        }
        return;
      }

      let height =
        (flood_level_mdpl_meter_editable - min_mdpl) * enlarge_extrude;

      if (height < 0) height = 0;

      if (!geojson_flood_square) {
        throw new Error("GeoJSON grid elevation data is missing");
      }

      try {
        if (!map_object.getSource("geojson_flood_square")) {
          map_object.addSource("geojson_flood_square", {
            type: "geojson",
            data: geojson_flood_square,
            tolerance: 0,
          });
        } else {
          const source = map_object.getSource("geojson_flood_square");
          if (source) {
            source.setData(geojson_flood_square);
          }
        }
      } catch (sourceError) {
        throw new Error(`Failed to add/update source: ${sourceError.message}`);
      }
      try {
        if (!map_object.getLayer("geojson_flood_square")) {
          map_object.addLayer({
            id: "geojson_flood_square",
            source: "geojson_flood_square",
            type: "fill-extrusion",
            paint: {
              "fill-extrusion-color": "#21a4f6",
              "fill-extrusion-height": height,
              "fill-extrusion-base": 0,
              "fill-extrusion-opacity": 0.6,
            },
            layout: {
              visibility: visibility_extrude,
            },
          });
          if (clickHandlerRef.current) {
            map_object.off(
              "click",
              "geojson_flood_square",
              clickHandlerRef.current
            );
          }
          clickHandlerRef.current = handleExtrusionClick;
          map_object.on("click", "geojson_flood_square", handleExtrusionClick);
          map_object.on("mouseenter", "geojson_flood_square", () => {
            map_object.getCanvas().style.cursor = "pointer";
          });
          map_object.on("mouseleave", "geojson_flood_square", () => {
            map_object.getCanvas().style.cursor = "";
          });
        } else {
          map_object.setPaintProperty(
            "geojson_flood_square",
            "fill-extrusion-color",
            "#21a4f6"
          );

          map_object.setPaintProperty(
            "geojson_flood_square",
            "fill-extrusion-height",
            height
          );
          map_object.setPaintProperty(
            "geojson_flood_square",
            "fill-extrusion-base",
            0
          );

          map_object.setPaintProperty(
            "geojson_flood_square",
            "fill-extrusion-opacity",
            0.6
          );
          map_object.setLayoutProperty(
            "geojson_flood_square",
            "visibility",
            visibility_extrude
          );
        }
      } catch (layerError) {
        throw new Error(`Failed to add/update layer: ${layerError.message}`);
      }
    } catch (error) {}
  }, [layer, genangan_reducer, handleExtrusionClick]);

  useEffect(() => {
    const { map_object } = layer;
    if (map_object) {
      on_render();
    }
    return () => {
      if (map_object && clickHandlerRef.current) {
        map_object.off(
          "click",
          "geojson_flood_square",
          clickHandlerRef.current
        );
        map_object.off("mouseenter", "geojson_flood_square");
        map_object.off("mouseleave", "geojson_flood_square");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    genangan_reducer.genangan_update,
    genangan_reducer.flood_level_mdpl_meter_editable,
    genangan_reducer.flood_level_cm_editable,
    genangan_reducer.enlarge_extrude,
    genangan_reducer.visibility_extrude,
  ]);

  return <main />;
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  properties: state.properties,
  genangan_reducer: state.genangan_reducer,
});

export default connect(mapStateToProps, {})(LAYER_EXTRUDE_FLOOD);
